/**
 * plugins/vuetify.ts
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
// After 'vuetify/styles' on purpose: it overrides rules of equal specificity.
import '@/styles/appearance.css'

// Composables
import { createVuetify } from 'vuetify'
import { vuetifyOptions } from './vuetifyOptions'

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify(vuetifyOptions)
